// Sticky mobile cart bar — appears when main ATC scrolls out of view on mobile
(function () {
  const bar = document.querySelector('.bs-mobile-bar');
  const trigger = document.querySelector('.bs-atc-btn');
  if (!bar || !trigger) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (window.innerWidth > 749) return;
      // Only show after the user has scrolled past the button (button above viewport top).
      // Avoids showing the bar on page load when the button is simply below the fold.
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('bs-mobile-bar--visible', scrolledPast);
    },
    { threshold: 0 }
  );

  observer.observe(trigger);

  // Wire up mobile bar ATC to submit the main form
  const mobileAtc = bar.querySelector('.bs-mobile-bar__btn');
  if (mobileAtc) {
    mobileAtc.addEventListener('click', () => {
      const mainForm = document.querySelector('.bs-hero__form');
      if (mainForm) mainForm.requestSubmit();
    });
  }
})();
